import { render, staticRenderFns } from "./MF3D.vue?vue&type=template&id=06d48b40&scoped=true&"
import script from "./MF3D.vue?vue&type=script&lang=js&"
export * from "./MF3D.vue?vue&type=script&lang=js&"
import style0 from "./MF3D.vue?vue&type=style&index=0&id=06d48b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d48b40",
  null
  
)

export default component.exports